import { Switch } from '@smart-kasa/ui';

import Field from '../Field/Field';

export const SwitchField = ({ name, ...props }) => (
  <Field name={name}>
    {({ input, ...rest }) => (
      <Switch
        {...input}
        {...rest}
        {...props}
        checked={input.value}
        onChange={(value) => input.onChange(value)}
      />
    )}
  </Field>
);
